<template>
  <div>
    <p
      v-if="!loading && definitions.length"
      class="caption blue-grey--text text--darken-3 mb-3"
      data-testid="routine-definitions-label-totalItems"
    >
      {{
        $t('common.resultWithCount', {
          count: totalRecords,
        })
      }}
    </p>
    <v-row class="ma-0 pa-0 mx-n2" v-if="!loading && definitions.length">
      <v-col
        v-for="item in definitions"
        class="mt-0 mb-4 px-2"
        cols="12"
        sm="6"
        md="4"
        lg="4"
        :key="item.definition.id"
      >
        <RoutineDefinitionCard
          :definition="item.definition"
          :selectedOrganizationId="organizationId"
          :searchHighlights="item.highlights"
          @getRoutines="$emit('getRoutines')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <v-pagination
          v-if="!loading && totalPages > 1"
          circle
          class="my-4"
          total-visible="10"
          :length="totalPages"
          :value="currentPage"
          @input="$emit('handlePageChange', $event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RoutineDefinitionCard from './RoutineDefinitionCard.vue'

export default {
  name: 'RoutineDefinitionsCardsView',

  components: {
    RoutineDefinitionCard,
  },

  props: {
    definitions: {
      type: Array,
      required: true,
    },
    organizationId: {
      type: String,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    totalRecords: {
      type: Number,
      required: true,
    },
  },
}
</script>
